import React from 'react';

import { CircularProgress } from '@material-ui/core';

import AnalysisCard from '../AnalysisCard/AnalysisCard';
import styles from './LoadingCard.module.scss';

const LoadingCard = () => {
	return (
		<AnalysisCard
			title="Generating ..."
			bottomAreaClassName={styles['root']}
		>
			<div className={styles['loading-wrapper']}>
				<CircularProgress size="50px" />
			</div>
		</AnalysisCard>
	);
};

export default LoadingCard;
